/**
 * Where to go after signing in. Only same-app paths are allowed, so a crafted
 * `?next=https://evil.example` (an open redirect) is ignored.
 */
export function safeNext(value: unknown, fallback = '/'): string {
  if (typeof value !== 'string') return fallback;
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return fallback;
  return value;
}
